import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { HomepageComponent } from './homepage/homepage.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomepageComponent,
    data: {
      tab: 'HOME',
      title: 'Code Race'
    }
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
    data: {
      robots: 'none',
      tab: 'ACCOUNT',
      title: 'Account'
    }
  },
  {
    path: 'contest',
    loadChildren: () => import('./contest/contest.module').then(m => m.ContestModule),
    data: {
      robots: 'none',
      tab: 'PROFILE',
      title: 'Contest'
    }
  },
  {
    path: 'create-account',
    loadChildren: () => import('./create-account/create-account.module').then(m => m.CreateAccountModule),
    data: {
      robots: 'none',
      title: 'Create Account'
    }
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
    data: {
      description: 'Code Race privacy policy.',
      keywords: 'Code Race, privacy policy',
      tab: 'ABOUT-US',
      title: 'Privacy Policy'
    }
  },
  {
    path: 'profile',
    loadChildren: () => import('./student-profile/student-profile.module').then(m => m.StudentProfileModule),
    data: {
      robots: 'none',
      tab: 'PROFILE',
      title: 'Student Profile'
    }
  },
  {
    path: 'ranking',
    loadChildren: () => import('./ranking/ranking.module').then(m => m.RankingModule),
    data: {
      tab: 'RANKING',
      title: 'Rankings'
    }
  },
  {
    path: 'reset',
    loadChildren: () => import('./reset/reset.module').then(m => m.ResetModule),
    data: {
      robots: 'none',
      tab: 'ACCOUNT',
      title: 'Reset Password'
    }
  },
  {
    path: 'results',
    loadChildren: () => import('./results/results.module').then(m => m.ResultsModule),
    data: {
      robots: 'none',
      tab: 'PROFILE',
      title: 'Results'
    }
  },
  {
    path: 'schedule',
    loadChildren: () => import('./schedule/schedule.module').then(m => m.ScheduleModule),
    data: {
      tab: 'SCHEDULE',
      title: 'Schedule'
    }
  },
  {
    path: 'sign-in',
    loadChildren: () => import('./sign-in/sign-in.module').then(m => m.SignInModule),
    data: {
      robots: 'none',
      tab: 'ACCOUNT',
      title: 'Sign In'
    }
  },
  {
    path: 'terms-of-service',
    loadChildren: () => import('./terms-of-service/terms-of-service.module').then(m => m.TermsOfServiceModule),
    data: {
      tab: 'ABOUT-US',
      title: 'Terms of Service'
    }
  },
  {
    path: 'trial',
    loadChildren: () => import('./trial/trial.module').then(m => m.TrialModule),
    data: {
      tab: 'TRIAL',
      title: 'Try a Challenge'
    }
  },
  {
    path: 'verify-email/:key',
    loadChildren: () => import('./verify-email/verify-email.module').then(m => m.VerifyEmailModule),
    data: {
      robots: 'none',
      title: 'Verify Email'
    }
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    //initialNavigation: 'enabledBlocking',
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
